export default __webpack_public_path__ + "static/media/camp412-2.c9f4a020.jpg";